import React, { Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
/**
 * Since components that compose the Story component pass down properties to children and in this case
 * the story component needs some wrappers around content to modify styling we need to create a
 * component proxy that will pass all the props received by the parent to the children component
 * we only leave className affecting the div inside the component
 */
const ComponentProxy = ({
  className = '',
  children,
  ...otherProps
}) => {
  // props to be passed down by the proxy won't include styles and children since those are defined separately
  // that's why the other_props object will be filtered to pass only the props that the child requires from the parent
  const childrenAndProps = Children.map(children, (child) => {
    const realProps = omit(otherProps, ['children', 'styles']);
    // props defined in children and passed by parent must not be overriden so the props need to be combined
    return isValidElement(child) ? cloneElement(child, { ...realProps, ...child.props}) : child;
  });

  return (
    <div className={className}>
      {childrenAndProps}
    </div>
  );
};

ComponentProxy.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired
};

export default ComponentProxy;
